'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ReactCSSTransitionGroup = require('react/lib/ReactCSSTransitionGroup');

var _ReactCSSTransitionGroup2 = _interopRequireDefault(_ReactCSSTransitionGroup);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Portal = require('./Portal');

var _Portal2 = _interopRequireDefault(_Portal);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _reactFixedPage = require('react-fixed-page');

var _reactFixedPage2 = _interopRequireDefault(_reactFixedPage);

var _reactDemo = require('react-demo');

var _reactDemo2 = _interopRequireDefault(_reactDemo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ESCAPE_KEYCODE = 27;

var ModalBody = function ModalBody(_ref) {
  var className = _ref.className,
      rest = _objectWithoutProperties(_ref, ['className']);

  return _react2.default.createElement('section', _extends({ className: (0, _classnames2.default)('pd-md', className) }, rest));
};

var ModalFooter = function ModalFooter(_ref2) {
  var className = _ref2.className,
      children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, ['className', 'children']);

  return _react2.default.createElement(
    'footer',
    _extends({ className: (0, _classnames2.default)('display-flex justify-content-flex-end pd-md', className) }, rest),
    _react2.default.createElement(
      'div',
      { className: 'flex-shrink-0' },
      children
    )
  );
};

var CloseButton = function CloseButton(_ref3) {
  var rest = _objectWithoutProperties(_ref3, []);

  return _react2.default.createElement(
    'div',
    _extends({ className: 'flex-shrink-0 cursor-pointer color-light-gray hover-color-fastmodel-gray' }, rest),
    _react2.default.createElement(_Icon2.default, { name: 'times' })
  );
};

var ModalTitle = function ModalTitle(_ref4) {
  var className = _ref4.className,
      onClose = _ref4.onClose,
      children = _ref4.children,
      style = _ref4.style,
      rest = _objectWithoutProperties(_ref4, ['className', 'onClose', 'children', 'style']);

  return _react2.default.createElement(
    'header',
    { className: (0, _classnames2.default)('pd-md display-flex flex-direction-row align-items-center', className),
      style: _extends({ borderBottom: '1px solid rgba(0,0,0,0.2)' }, style) },
    _react2.default.createElement(
      'h4',
      { style: { margin: 0 }, className: 'flex-grow-1' },
      children
    ),
    onClose != null ? _react2.default.createElement(CloseButton, { onClick: function onClick() {
        return onClose();
      } }) : null
  );
};

var ModalTransition = function ModalTransition(_ref5) {
  var props = _objectWithoutProperties(_ref5, []);

  return _react2.default.createElement(_ReactCSSTransitionGroup2.default, _extends({ transitionName: 'Modal',
    transitionEnterTimeout: 300,
    transitionLeaveTimeout: 300 }, props));
};

var Modal = function (_PureComponent) {
  _inherits(Modal, _PureComponent);

  function Modal() {
    var _ref6;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref6 = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref6, [this].concat(args))), _this), _this.focusModalSection = function () {
      var section = _this.refs.section;

      if (section) {
        section.focus();
      }
    }, _this.handleBackdropClick = function () {
      var _this$props = _this.props,
          backdrop = _this$props.backdrop,
          onClose = _this$props.onClose;


      if (backdrop !== 'static') {
        onClose();
      }
    }, _this.handleKeyDown = function (_ref7) {
      var keyCode = _ref7.keyCode;
      var onClose = _this.props.onClose;


      if (keyCode === ESCAPE_KEYCODE) {
        onClose();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var open = this.props.open;


      if (open && !prevProps.open) {
        // we need a timeout because this should happen *after* the portal renders it to the DOM
        setTimeout(this.focusModalSection, 0);
      }
    }
  }, {
    key: 'renderModalSection',
    value: function renderModalSection() {
      var _props = this.props,
          open = _props.open,
          backdrop = _props.backdrop,
          size = _props.size,
          aside = _props.aside,
          children = _props.children;


      if (!open) {
        return null;
      }

      var backdropEl = backdrop !== false ? _react2.default.createElement('div', { key: 'backdrop', className: 'Modal--backdrop', onClick: this.handleBackdropClick }) : null;

      return _react2.default.createElement(
        'section',
        { className: 'Modal--container', ref: 'section', onKeyDown: this.handleKeyDown, tabIndex: -1 },
        backdropEl,
        _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)('display-flex justify-content-center', _defineProperty({}, 'Modal--dialog-aside aside-' + aside, aside != null)) },
          _react2.default.createElement(
            'div',
            { className: 'Modal--content ' + size },
            children
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          _Portal2.default,
          null,
          _react2.default.createElement(
            ModalTransition,
            null,
            this.renderModalSection()
          )
        ),
        _react2.default.createElement(_reactFixedPage2.default, { fixed: this.props.open })
      );
    }
  }]);

  return Modal;
}(_react.PureComponent);

Modal.Title = ModalTitle;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;
Modal.propTypes = {
  open: _react.PropTypes.bool.isRequired,
  onClose: _react.PropTypes.func.isRequired,
  backdrop: _react.PropTypes.oneOf([true, false, 'static']),
  size: _react.PropTypes.oneOf(['xs', 'sm', 'lg']),
  // the level of stacking to render at
  aside: _react.PropTypes.oneOf([null, 1, 2, 3, 4, 5])
};
Modal.defaultProps = {
  backdrop: 'static',
  size: 'sm',
  aside: null
};

Modal.demo = function () {
  return _react2.default.createElement(
    _reactDemo2.default,
    { props: {
        open: _reactDemo.props.bool(false),
        hasTitle: _reactDemo.props.bool(true),
        hasFooter: _reactDemo.props.bool(true),
        hasBody: _reactDemo.props.bool(true),
        backdrop: _reactDemo.props.choices([true, false, 'static']),
        size: _reactDemo.props.choices(['xs', 'sm', 'lg']),
        aside: _reactDemo.props.choices([null, 1, 2, 3, 4, 5])
      } },
    function (props, update) {
      return _react2.default.createElement(
        Modal,
        _extends({}, props, { onClose: function onClose() {
            return update({ open: false });
          } }),
        props.hasTitle && _react2.default.createElement(
          Modal.Title,
          { onClose: function onClose() {
              return update({ open: false });
            } },
          'This is the title'
        ),
        props.hasBody && _react2.default.createElement(
          Modal.Body,
          null,
          'This is the body'
        ),
        props.hasFooter && _react2.default.createElement(
          Modal.Footer,
          null,
          'This is the footer'
        )
      );
    }
  );
};

exports.default = Modal;


//////////////////
// WEBPACK FOOTER
// ./~/react-fast-ui/lib/components/Modal.js
// module id = 403
// module chunks = 0